import { useEffect, useState } from "react";
import { toast } from "sonner";
import { Loader2, Mail, Send, ExternalLink } from "lucide-react";
import { api } from "@/lib/api";

export function RadioBirthAdmin() {
  const [st, setSt] = useState(null);
  const [busy, setBusy] = useState("");
  const load = () => api.get("/admin/radio/birth").then(({ data }) => setSt(data)).catch(() => {});
  useEffect(() => { load(); }, []);

  const test = async () => {
    setBusy("test");
    try { const { data } = await api.post("/admin/radio/birth/test"); data.ok ? toast.success(`Test envoyé à ${data.to}`) : toast.error("L'envoi du test a échoué"); }
    catch { toast.error("L'envoi du test a échoué"); } finally { setBusy(""); }
  };
  const broadcast = async () => {
    const n = (st?.audience.members || 0) + (st?.audience.newsletter || 0);
    if (!window.confirm(`Envoyer « La naissance de Radio Cocoon » à environ ${n} personnes (membres + abonnés, sans doublon) ? Cet envoi ne peut être fait qu'une seule fois.`)) return;
    setBusy("all");
    try { await api.post("/admin/radio/birth/broadcast"); toast.success("Envoi lancé — il se poursuit en arrière-plan"); load(); }
    catch (e) { toast.error(e?.response?.data?.detail || "Envoi impossible"); } finally { setBusy(""); }
  };

  const b = st?.broadcast;
  return (
    <div className="mb-8 rounded-2xl border border-primary/25 bg-primary/[0.05] p-5" data-testid="admin-radio-birth">
      <div className="flex flex-wrap items-center gap-3 mb-2">
        <Mail size={16} className="text-primary" />
        <h3 className="font-display text-xl">Annonce « La naissance de Radio Cocoon »</h3>
        <a href="/radio/naissance" target="_blank" rel="noreferrer" className="ml-auto inline-flex items-center gap-1 text-xs text-primary/80 hover:text-primary" data-testid="admin-radio-birth-page">Voir la page <ExternalLink size={12} /></a>
      </div>
      <p className="text-sm text-foreground/60 mb-4">
        Envoyée automatiquement à chaque nouveau membre (1 min 30 après l'inscription). Envoi unique possible aux {st?.audience.members ?? "…"} membres et {st?.audience.newsletter ?? "…"} abonnés newsletter confirmés.
      </p>
      <div className="flex flex-wrap items-center gap-3">
        <button onClick={test} disabled={!!busy} data-testid="admin-radio-birth-test"
          className="inline-flex items-center gap-2 rounded-full border border-primary/40 px-4 py-2 text-sm text-primary hover:bg-primary/10 disabled:opacity-50">
          {busy === "test" ? <Loader2 size={14} className="animate-spin" /> : <Mail size={14} />} M'envoyer un test
        </button>
        <button onClick={broadcast} disabled={!!busy || !!b} data-testid="admin-radio-birth-broadcast"
          className="inline-flex items-center gap-2 rounded-full bg-primary text-background font-semibold px-5 py-2 text-sm disabled:opacity-40">
          {busy === "all" ? <Loader2 size={14} className="animate-spin" /> : <Send size={14} />} Envoyer à tous (une fois)
        </button>
        {b && (
          <span className="text-xs text-foreground/60" data-testid="admin-radio-birth-status">
            {b.done_at ? `Envoyée le ${new Date(b.done_at).toLocaleString()} — ${b.sent}/${b.targets} emails` : "Envoi en cours…"}
          </span>
        )}
      </div>
    </div>
  );
}
